import { render } from "./TeamSelection.vue?vue&type=template&id=6154c386&scoped=true"
import script from "./TeamSelection.vue?vue&type=script&lang=js"
export * from "./TeamSelection.vue?vue&type=script&lang=js"

import "./TeamSelection.vue?vue&type=style&index=0&id=6154c386&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6154c386"]])

export default __exports__